var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"variant-fulfillment-column"},[_c('multi-select-column',{attrs:{"label-key":"name","value-key":"id","options":_vm.product.fulfillmentMethods,"empty-text":"Not Required","value":_vm.value},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }